<span class="icon-holder" (click)="onClickAction()" [ngClass]="{'disabled': isDisabled, 'with-shadow': addShadow}">
  <i [class]="iconClass"></i>
</span>